import type { PageTypes } from '~/lib/data-contract';
import P170AviouPage from '../../P170AviouPage';
import GiftCardBalancePage from '../../GiftCardBalancePage';
import P50ProductDetailsPage from '../../P50ProductDetailsPage';
import P80FavoritePage from '../../P80FavoritePage';
import P60ModulePage from '../../P60ModulePage';
import P70FindStoresPage from '../../P70FindStores';
import P20FrontPage from '../../P20FrontPage';
import P71StoreDetailsPage from '../../P71StoreDetailsPage';
import P160ArticlePage from '../../P160ArticlePage';
import P165ArticleListPage from '../../P165ArticleListPage';
import BrandsListPage from '../../BrandsListPage';
import PLPPage from '../../PLPPage';
import P100CheckoutPage from '../../P100CheckoutPage';
import P90BasketPage from '../../P90BasketPage';
import P90BasketPage1 from '../../P90BasketPage1';
import P125MyProfilePage from '../../P125MyProfilePage';
import ReceiptPage from '../../ReceiptPage';
import P10SearchPage from '../../P10SearchPage';
import { P150ErrorPage } from '../../P150ErrorPage/P150ErrorPage';

type PageTypeKey = keyof PageTypes;

export function getDynamicPage(type: PageTypeKey): PageTypes[PageTypeKey] {
    switch (type) {
        case 'p60ModulePage':
            return P60ModulePage;
        case 'p80FavoritePage':
            return P80FavoritePage;
        case 'p50ProductDetailsPage':
            return P50ProductDetailsPage;
        case 'giftCardBalancePage':
            return GiftCardBalancePage;
        case 'p170AviouPage':
            return P170AviouPage;
        case 'p20FrontPage':
            return P20FrontPage;
        case 'p70FindStores':
            return P70FindStoresPage;
        case 'p71StoreDetailsPage':
            return P71StoreDetailsPage;
        case 'p160ArticlePage':
            return P160ArticlePage;
        case 'articleListPage':
            return P165ArticleListPage;
        case 'brandsListPage':
            return BrandsListPage;
        case 'p40ProductListPage':
            return PLPPage;
        case 'p100CheckoutPage':
            return P100CheckoutPage;
        case 'p90BasketPage':
            return P90BasketPage;
        case 'p90BasketPage1':
            return P90BasketPage1;
        case 'p125MyProfilePage':
            return P125MyProfilePage;
        case 'p150ErrorPage':
            return P150ErrorPage;
        case 'receiptPage':
            return ReceiptPage;
        case 'p10SearchPage':
            return P10SearchPage;

        /** Fallback */
        default:
            return P60ModulePage;
    }
}
